import React, { useState } from "react";
import ManualMeditionModal from "./manual-medition-modal";
import ReactDOMServer from 'react-dom/server';
import Swal from "sweetalert2"
import { FaCube, FaRegSquare, FaWindows, FaTimes } from "react-icons/fa";
import './entries.css'
import PalletSelectionModal from "./pallet-selection-modal";

function CubiscanForm({ master, subproduct }) {
    const [showPopup, setShowPopup] = useState(false);
    const [showPopupTwo, setShowPopupTwo] = useState(false);
    const [activeCheckbox, setActiveCheckbox] = useState(null);
    const [showAlert, setShowAlert] = useState(false);
    const [showButtons, setShowButtons] = useState(false);

    const handleUpdate = () => {
        alert('Actualizar')
    }

    const handleSave = () => {
        if (!activeCheckbox) {
            setShowAlert(true);
            return;
        }

        setShowAlert(false);  // ocultar mensaje si si hay algun checkbox seleccionado
        setShowButtons(true); 
        alert('Guardar')
    }

    const handleExcludelMedition = () => {
        // Primer mensaje
        const firstHtml = ReactDOMServer.renderToString(
          <div className="container-fluid">
            <p>¿Seguro que desea excluir la medición del Cubiscan?</p>
          </div>
        );
      
        Swal.fire({
          title: '',
          html: firstHtml,
          showCancelButton: true,
          confirmButtonText: 'Aceptar',
          cancelButtonText: 'Cancelar',
          icon: 'warning',
          customClass: {
            confirmButton: 'btn-okk',
            cancelButton: 'btn-canceel',
            popup: 'alert-bg',
          },
        }).then((result) => {
          if (result.isConfirmed) {
            // Segundo mensaje
            const secondHtml = ReactDOMServer.renderToString(
              <div className="container-fluid">
                <p className="fw-bold">¿Seguro que quieres aceptar la guía?</p>
                <small style={{color:'#DC3545', fontWeight:'700'}}>Esta acción es irreversible.</small>
              </div>
            );
      
            Swal.fire({
              title: '',
              html: secondHtml,
              showCancelButton: true,
              confirmButtonText: 'Aceptar',
              cancelButtonText: 'Cancelar',
              icon: 'warning',
              customClass: {
                confirmButton: 'btn-okk',
                cancelButton: 'btn-canceel',
                popup: 'alert-bg',
              },
            }).then((finalResult) => {
              if (finalResult.isConfirmed) {
                // Aquí va la lógica final
                console.log('Guía aceptada');
              }
            });
          }
        });
    };

    return(
        <>
            <div className="container-fluid">
                <div className="row">
                    <div className="col-3">
                        <p><span className="fw-bold">Master:</span> {master.number} </p>
                    </div>
                    <div className="col-3">
                        <p><span className="fw-bold">Origen:</span> {master.number} </p>
                    </div>
                    <div className="col-3">
                        <p><span className="fw-bold">Destino:</span> {master.number} </p>
                    </div>
                    <div className="col-3">
                        <p><span className="fw-bold">Tipo de mercancía:</span> {master.number} </p>
                    </div>
                </div>
                <div className="row">
                    <div className="col-3">
                        <p><span className="fw-bold">Piezas Master:</span> {master.number} </p>
                    </div>
                    <div className="col-3">
                        <p><span className="fw-bold">Peso Master:</span> {master.number} </p>
                    </div>
                    <div className="col-3">
                        <p><span className="fw-bold">Volúmen Master:</span> {master.number} </p>
                    </div>
                    {subproduct && (
                        <div className="col-3">
                            <p><span className="fw-bold">HBS:</span> {subproduct.hbs} </p>
                        </div>
                    )}
                </div>
                {subproduct && (
                    <div className="row">
                        <div className="col-3">
                            <p><span className="fw-bold">Piezas House:</span> {subproduct.piezas} </p>
                        </div>
                        <div className="col-3">
                            <p><span className="fw-bold">Peso House:</span> {subproduct.peso} </p>
                        </div>
                        <div className="col-3">
                            <p><span className="fw-bold">Volúmen House:</span> {subproduct.volume} </p>
                        </div>
                    </div>
                )}
                <div className="row">
                    <div className="col-6">
                        <button className="btn btn-danger" onClick={handleExcludelMedition}>Excluir medición cubiscan</button>
                    </div>
                    <div className="col-6 text-end">
                        <button className="btnn" onClick={() => setShowPopup(true)}>Medición manual</button>
                        {activeCheckbox === "check1" && showButtons && (
                            <button className="btnn me-2" onClick={() => alert("Guía aceptada")}>Aceptar guía</button>
                        )}
                    </div>
                </div>

                <table className="table table-striped mt-3">
                    <thead className="text-center">
                        <tr>
                            <th style={{ backgroundColor: '#020C41', color: 'white' }}>Nombre archivo</th>
                            <th style={{ backgroundColor: '#020C41', color: 'white' }}>Gross Weight <FaCube /> </th>
                            <th style={{ backgroundColor: '#020C41', color: 'white' }}>Gross Volume <FaCube /> </th>
                            <th style={{ backgroundColor: '#020C41', color: 'white' }}>Real Weight <FaRegSquare /> </th>
                            <th style={{ backgroundColor: '#020C41', color: 'white' }}>Real Volume <FaRegSquare /> </th>
                            <th style={{ backgroundColor: '#020C41', color: 'white' }}>Acciones</th>
                        </tr>
                    </thead>
                    <tbody className="text-center">
                        <tr>
                            <td>
                                Ejemplo
                            </td>
                            <td>
                                128
                            </td>
                            <td>
                                0 m3
                            </td>
                            <td>
                                0
                            </td>
                            <td>
                                0 m3
                            </td>
                            <td>
                                <FaCube size={20} style={{marginRight:'5px', color: '#020C41' }}/>
                                <input 
                                    className="form-check-input" 
                                    type="checkbox" 
                                    name="check1" 
                                    checked={activeCheckbox === "check1"} 
                                    onChange={() => {
                                        setActiveCheckbox("check1");
                                        setShowButtons(false);
                                    }} 
                                    style={{marginRight:'20px'}} 
                                />

                                <FaRegSquare size={20} style={{marginRight:'5px', color: '#020C41' }}/>
                                <input 
                                    className="form-check-input" 
                                    type="checkbox" 
                                    name="check2"
                                    checked={activeCheckbox === "check2"}
                                    onChange={() => {
                                        setActiveCheckbox("check2")
                                        setShowButtons(false);
                                    }} 
                                    style={{marginRight:'15px'}} 
                                />
                                <button 
                                    style={{border: 'none'}} 
                                    onClick={() => setShowPopupTwo(true)}
                                    disabled={activeCheckbox !== "check2"}
                                >
                                    <FaWindows
                                        size={20}
                                        style={{
                                            marginRight:'5px',
                                            transform: 'rotate(90deg)',
                                            color: activeCheckbox === "check2" ? "#020C41" : "#020C41",
                                            opacity: activeCheckbox === "check2" ? 1 : 0.4,
                                            transition: "all 0.2s ease-in-out"
                                        }}
                                    />
                                </button>
                                <button onClick={() => alert('Cerrar')} style={{ background: 'none', border: 'none', cursor: 'pointer' }}>
                                    <FaTimes size={20} style={{ color: '#020C41' }} />
                                </button>
                            </td>
                        </tr>
                    </tbody>
                </table>

                {showAlert && (
                    <div className="alert alert-danger" role="alert">
                        Se deben seleccionar todos los tipos de medición o eliminar las mediciones que no se utilizarán.
                    </div>
                )}

                <div className="row">
                    <div className="col mt-4 d-flex justify-content-end gap-3">
                        <button className='btnn' onClick={handleUpdate} >Actualizar</button>
                        <button className='btnn' onClick={handleSave} >Guardar</button>
                        {activeCheckbox === "check1" && showButtons && (
                            <button className='btnn' onClick={() => alert("Generar ticket")}>Ticket</button>
                        )}
                    </div>
                </div>

                {/* <div class="alert alert-success" role="alert">
                    Cumplio con el rango: <br />
                    Valores aceptados por el tipo de mercancía (remesa), se cobrara conforme los datos de la guia.                    
                </div> */}
            </div>
            {showPopup && <ManualMeditionModal master={master} onClose={() => setShowPopup(false)} />}
            {showPopupTwo && <PalletSelectionModal master={master} onClose={() => setShowPopupTwo(false)} />}
        </>
    );
}

export default CubiscanForm;